<template>
  <div
    :class="{
      'mb-6 flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-center': true,
    }"
    data-testid="EventFormatSideBar"
  >
    <h2
      :class="{
        'text-lg font-bold text-www-color-neutral-medium-dark': true,
      }"
    >
      Upcoming Events
    </h2>
    <div
      :class="{
        'flex w-full gap-3 overflow-x-auto sm:w-auto': true,
      }"
      aria-label="Filter events"
    >
      <button
        type="button"
        :class="{
          'min-w-20 rounded border px-4 py-2.5 text-sm font-medium transition-colors': true,
          'bg-[#0D3E62] text-www-color-white': props.selectedFormat === null,
          'border-[#D9D9D9] bg-www-color-transparent text-[#0D3E62]': props.selectedFormat !== null,
        }"
        data-testid="eventFormatOption-all"
        @click="onSelect(null)"
      >
        All
      </button>
      <button
        v-for="filter in props.formatOptions"
        :key="filter.value"
        type="button"
        :class="{
          'min-w-20 rounded border px-4 py-2.5 text-sm font-medium transition-colors': true,
          'bg-[#0D3E62] text-www-color-white': props.selectedFormat === filter.value,
          'border-[#D9D9D9] bg-www-color-transparent text-[#0D3E62]':
            props.selectedFormat !== filter.value,
        }"
        :data-testid="`eventFormatOption-${filter.value}`"
        @click="onSelect(filter.value)"
      >
        {{ filter.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { EventFormatOption, EventFormatValue } from '~/composables/useEventFilter';

interface PropsType {
  formatOptions: Array<EventFormatOption>;
  selectedFormat: EventFormatValue | null;
}
const props = defineProps<PropsType>();

const emit = defineEmits<{
  formatChange: [format: EventFormatValue | null];
}>();

const onSelect = (format: EventFormatValue | null): void => {
  emit('formatChange', format);
};
</script>
